const API_URL = "https://blogfreerecipe-api.onrender.com";
//process.env.REACT_APP_API_URL || "https://blogfreerecipe-api.onrender.com";

export async function claimPendingRecipe(accessToken) {
  let pending;
  try {
    pending = JSON.parse(localStorage.getItem("pendingRecipeClaim"));
  } catch {
    localStorage.removeItem("pendingRecipeClaim");
    return;
  }
  if (!pending?.recipeId || !pending?.claimToken) return;

  try {
    const response = await fetch(
      `${API_URL}/api/recipes/${pending.recipeId}/claim`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ claimToken: pending.claimToken }),
      },
    );

    // Claimed, or permanently unclaimable (bad token, already claimed): stop trying
    if (response.ok || response.status === 400 || response.status === 403) {
      localStorage.removeItem("pendingRecipeClaim");
    }
  } catch (err) {
    // Network error: keep it so it can retry on the next sign-in
    console.error("Recipe claim failed:", err);
  }
}
